import React from 'react';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react';
import styled, { css } from 'styled-components/macro';

import { useDataStore } from 'state/DataStore';

const AvailableUnitsBox = observer(({ availableUnits = [], availableText = '', currentUnit = null, soldOutMessage = 'SOLD OUT' }) => {
    const dataStore = useDataStore();

    const getUnitElement = (unit) => {
        return currentUnit?.id === unit.id ? 'div' : Link;
    };

    if (availableUnits.length > 0) {
        return (
            <UnitsAvailableBox>
                <AvailableText className="h6">
                    {availableText}
                </AvailableText>
                <Divider />
                <AvailableUnits>
                    {availableUnits.map(unit => (
                        <AvailableUnit as={getUnitElement(unit)} to={dataStore.getUnitPath(unit) || '#'} key={unit.id} $isCurrent={currentUnit?.id === unit.id}>{unit.title.rendered}</AvailableUnit>
                    ))}
                </AvailableUnits>
            </UnitsAvailableBox>
        );
    }

    return (
        <SoldOutBox>
            <AvailableText className="h6">
                {soldOutMessage}
            </AvailableText>
        </SoldOutBox>
    );
});

export default AvailableUnitsBox;

const UnitsAvailableBox = styled.div`
    position: absolute;
    bottom: 12rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 2rem;
    padding: 1.25rem 3.5rem;
    color: ${props => props.theme.primary_color};
    background-color: ${props => props.theme.secondary_color_light};
`;

const SoldOutBox = styled.div`
    position: absolute;
    bottom: 12rem;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 2rem;
    padding: 1.25rem 3.5rem;
    color: white;
    background-color: ${props => props.theme.sold_color};
`;

const AvailableText = styled.div`
    white-space: nowrap;
`;

const Divider = styled.div`
    height: 2.5rem;
    width: .1rem;
    background-color: ${props => props.theme.secondary_color};
`;

const AvailableUnits = styled.div`
    display: flex;
    align-items: center;
    gap: 1.5rem;
`;

const AvailableUnit = styled(Link)`
    color: ${props => props.theme.primary_color};

    &:hover {
        color: ${props => props.theme.accent_color};
    }

    ${props => props.$isCurrent && css`
        color: ${props.theme.primary_color_light};

        &:hover {
            color: ${props.theme.primary_color_light};
        }
    `}
`;
